import { Component, OnInit } from '@angular/core';
import { Globals } from '@app/shared/models/globals';
import { chartStoreUrl } from '@app/constants/config-common';

@Component({
  selector: 'app-axiom-page',
  templateUrl: './axiom-page.component.html',
  styleUrls: ['./axiom-page.component.scss']
})
export class AxiomPageComponent implements OnInit {
  chartStoreUrl = chartStoreUrl;

  constructor(private globals: Globals) { }

  ngOnInit() {
    this.globals.isActive = false;
  }

}
